import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import axios from '../../services/axiosInstance';
import styles from './PostOptions.module.css';

export default function PostOptions({ post, userId, onChange }) {
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState(null);
  const [caption, setCaption] = useState(post.caption || '');
  const [busy, setBusy] = useState(false);
  const root = useRef(null);
  const trigger = useRef(null);
  const dialog = useRef(null);
  const own = String(post.user_id ?? post.user.id) === String(userId);
  const close = () => { if (!busy) { setAction(null); trigger.current?.focus(); } };
  useEffect(() => {
    const outside = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    document.addEventListener('pointerdown', outside);
    return () => document.removeEventListener('pointerdown', outside);
  }, []);
  useEffect(() => { if (action) dialog.current?.focus(); }, [action]);
  const submit = async event => {
    event.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      if (action === 'edit') {
        const response = await axios.patch(`/posts/${post.id}`, { caption });
        onChange({ ...post, caption: response.data.post.caption });
      } else {
        await axios.delete(`/posts/${post.id}`);
        onChange(null);
      }
      setAction(null);
      toast.success(action === 'edit' ? 'Publicação atualizada.' : 'Publicação excluída.');
    } catch (error) { toast.error(error.response?.data?.message || 'Não foi possível concluir. Tente novamente.'); }
    finally { setBusy(false); }
  };
  return <div className={styles.root} ref={root} onKeyDown={event => { if (event.key === 'Escape') { setOpen(false); close(); } }}>
    <button ref={trigger} className={styles.trigger} type="button" aria-label="Opções da publicação" aria-expanded={open} onClick={() => setOpen(!open)}>•••</button>
    {open && <div className={styles.menu}>
      {own && <><button onClick={() => { setCaption(post.caption || ''); setAction('edit'); setOpen(false); }}>Editar</button><button onClick={() => { setAction('delete'); setOpen(false); }}>Excluir</button></>}
      <button onClick={() => { setAction('details'); setOpen(false); }}>Detalhes</button>
    </div>}
    {action && <div className={styles.backdrop} onClick={close}><section className={styles.dialog} role="dialog" aria-modal="true" aria-label={action === 'edit' ? 'Editar publicação' : action === 'delete' ? 'Excluir publicação' : 'Detalhes da publicação'} ref={dialog} tabIndex={-1} onClick={event => event.stopPropagation()} onKeyDown={event => {
      if (event.key !== 'Tab') return;
      const elements = event.currentTarget.querySelectorAll('button:not(:disabled), textarea:not(:disabled)');
      const first = elements[0], last = elements[elements.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog.current)) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }}>
      <h2>{action === 'edit' ? 'Editar publicação' : action === 'delete' ? 'Excluir publicação?' : 'Detalhes da publicação'}</h2>
      {action === 'details' ? <><p>@{post.user.username}</p><p>{post.caption}</p><p>{new Date(post.createdAt).toLocaleString('pt-BR')}</p><p>{post.likes?.length || 0} curtidas · {post.comments?.length || 0} comentários</p><button onClick={close}>Fechar</button></> : <form onSubmit={submit}>
        {action === 'edit' ? <label>Legenda<textarea value={caption} onChange={event => setCaption(event.target.value)} maxLength={255} required disabled={busy} /></label> : <p>A foto, curtidas, comentários e peças originadas nesta publicação serão excluídos. Esta ação não pode ser desfeita.</p>}
        <div className={styles.actions}><button type="button" onClick={close} disabled={busy}>Cancelar</button><button type="submit" disabled={busy || (action === 'edit' && !caption.trim())}>{busy ? 'Aguarde...' : action === 'edit' ? 'Salvar' : 'Excluir'}</button></div>
      </form>}
    </section></div>}
  </div>;
}
